import { bucketForHours } from './hourBuckets';

export const WORKER_SCOPES = {ALL: 'all', INSPECTORS: 'inspectors'};

export function homesInScope(homes, scope) {
    return scope === WORKER_SCOPES.INSPECTORS ? homes.filter(home => home.is_inspector) : homes;
}

// An empty selection means everyone in the scope.
export function filterHomes(homes, scope, userIds) {
    const inScope = homesInScope(homes, scope);
    return userIds.length > 0 ? inScope.filter(home => userIds.indexOf(home.user_id) !== -1) : inScope;
}

// Every call is in one category: no date makes it not scheduled, whoever is on it; otherwise assigned or unassigned.
function isCategoryShown(block, {showAssigned, showUnassigned, showUnscheduled}) {
    if(!block.scheduled_date) {
        return showUnscheduled;
    }

    return block.technicians.length > 0 ? showAssigned : showUnassigned;
}

// The worker filter can only narrow calls that have a worker.
function isWorkerShown(block, {scope, userIds}) {
    return block.technicians.length === 0 || block.technicians.some(technician =>
        (scope === WORKER_SCOPES.ALL || technician.is_inspector)
        && (userIds.length === 0 || userIds.indexOf(technician.id) !== -1)
    );
}

export function isCallVisible(block, filters) {
    return !block.completed
        && !block.pending
        && isCategoryShown(block, filters)
        && filters.hiddenHours.indexOf(bucketForHours(block.work_hours).key) === -1
        && isWorkerShown(block, filters);
}

export function countCalls(blocks) {
    const scheduled = blocks.filter(block => block.scheduled_date);
    const assigned = scheduled.filter(block => block.technicians.length > 0).length;

    return {assigned, unassigned: scheduled.length - assigned, unscheduled: blocks.length - scheduled.length};
}
